import { Link } from "react-router";

import Error404Image from "../assets/images/404.gif";
import { Image } from "../components/Image";

import "../assets/scss/pages/_error-404.scss";

export const Error404 = ({ params }) => {

	const url = `/${params.type ? params.type : ""}${params.item ? `/${params.item}` : ""}`;

	console.error("404 Error: At location: ", url, " - This page does not exist.");

	return (
		<section className="page-404">
			<div className="error404-image">
				<Image src={Error404Image} alt="404 Error" />
			</div>
			<h3>
				Oops!
				<br />
				This flower is yet to bloom!
			</h3>

			<div className="muted">(Error 404)</div>

			<p>If you think this is a mistake then please get in touch with our customer service team.</p>
			<div className="muted url">{url}</div>
			<Link to="/" className="btn">
				Back To Homepage
			</Link>
		</section>
	);
};

export default Error404;
